var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_71939",
    "data-name": "Group 71939",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27583",
    "data-name": "Rectangle 27583",
    width: 81,
    height: 81,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_71933",
    "data-name": "Group 71933",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7868",
    "data-name": "Path 7868",
    d: "M9.786,11.815H35.432a2.029,2.029,0,1,0,0-4.058H9.786a2.029,2.029,0,0,0,0,4.058",
    transform: "translate(5.066 5.066)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7869",
    "data-name": "Path 7869",
    d: "M23.273,17.545A2.031,2.031,0,0,0,25.3,19.573H38.124a2.029,2.029,0,1,0,0-4.058H25.3a2.031,2.031,0,0,0-2.028,2.03",
    transform: "translate(15.199 10.132)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7870",
    "data-name": "Path 7870",
    d: "M9.786,19.573H29.023a2.028,2.028,0,1,0,0-4.057H9.786a2.028,2.028,0,1,0,0,4.057",
    transform: "translate(5.066 10.133)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7871",
    "data-name": "Path 7871",
    d: "M28.366,23.274H18.15a2.028,2.028,0,0,0,0,4.057H28.366a2.028,2.028,0,1,0,0-4.057",
    transform: "translate(10.529 15.199)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7872",
    "data-name": "Path 7872",
    d: "M9.786,27.332H17.2a2.028,2.028,0,1,0,0-4.057H9.786a2.028,2.028,0,1,0,0,4.057",
    transform: "translate(5.066 15.2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7873",
    "data-name": "Path 7873",
    d: "M9.786,35.089H30.621a2.028,2.028,0,1,0,0-4.057H9.786a2.028,2.028,0,1,0,0,4.057",
    transform: "translate(5.066 20.266)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7874",
    "data-name": "Path 7874",
    d: "M26.7,38.79H20.7a2.028,2.028,0,1,0,0,4.057H26.7a2.028,2.028,0,1,0,0-4.057",
    transform: "translate(12.191 25.332)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7875",
    "data-name": "Path 7875",
    d: "M21.409,38.79H9.786a2.028,2.028,0,1,0,0,4.057H21.409a2.028,2.028,0,1,0,0-4.057",
    transform: "translate(5.066 25.332)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7876",
    "data-name": "Path 7876",
    d: "M75.575,53.111a1.967,1.967,0,0,0-1.486.415,2.018,2.018,0,0,0-.764,1.374,13.846,13.846,0,1,1-4.08-11.476,2.029,2.029,0,1,0,2.837-2.9,17.823,17.823,0,0,0-3.906-2.893V14.853a2.048,2.048,0,0,0-.593-1.435L54.756.592A2.021,2.021,0,0,0,53.323,0H2.028A2.031,2.031,0,0,0,0,2.03V78.972A2.031,2.031,0,0,0,2.028,81H66.147a2.031,2.031,0,0,0,2.028-2.028V69.017a17.829,17.829,0,0,0,9.181-13.661,2.029,2.029,0,0,0-1.782-2.245M55.353,12.823V6.928l5.9,5.895Zm-2.03,4.058H64.117V36.02a17.9,17.9,0,1,0,0,34.6v6.321H4.057V4.057H51.294V14.851a2.031,2.031,0,0,0,2.028,2.03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7877",
    "data-name": "Path 7877",
    d: "M61.152,25.084a2.03,2.03,0,0,0-2.868,0L40.32,43.047l-7.381-7.384a2.029,2.029,0,1,0-2.868,2.871l8.816,8.816a2.031,2.031,0,0,0,2.87,0l19.4-19.4a2.028,2.028,0,0,0,0-2.868",
    transform: "translate(19.251 15.994)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoFile);
export default __webpack_public_path__ + "static/media/info_file.1e819e574c0183c836ae39425875318e.svg";
export { ForwardRef as ReactComponent };